var _style, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowLaneChangeRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 80 80",
    height: 80,
    width: 80,
    style: {
      enableBackground: "new 0 0 80 80"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#6E625E;stroke:#FAF9F7;stroke-width:1.5;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M13.1,76.4V63.7c0-0.4,0-0.9,0-1.3c0.2-3.3,1.1-6.5,2.6-9.3c3.3-6.5,9.6-11.2,17.1-12.3c0.4,0,0.8-0.1,1.2-0.1 c0.3,0,0.7-0.1,1-0.1c0.5,0,0.9,0,1.4,0l0.1,0c0.6,0,1.2-0.1,1.8-0.2c0.1,0,0.2,0,0.2,0c0.6-0.1,1.1-0.3,1.6-0.5 c3.5-1.3,5.9-4.7,5.9-8.7l0-9L34.7,22L53.4,3.2L72,22H60.3l0.1,9.7c0,1.3-0.1,2.5-0.3,3.7c-0.1,0.6-0.2,1.3-0.4,1.9l0,0 c-0.2,0.8-0.5,1.6-0.8,2.4c-0.1,0.4-0.3,0.9-0.5,1.3c-0.2,0.4-0.3,0.7-0.5,1c-0.4,0.9-0.9,1.8-1.5,2.6c-0.2,0.1-0.3,0.3-0.4,0.5 c-0.3,0.5-0.7,0.9-1,1.3c-0.2,0.3-0.5,0.6-0.7,0.8c-0.2,0.3-0.5,0.6-0.7,0.8c-1.2,1.1-2.4,2.1-3.8,3c-2.2,1.4-4.6,2.5-7.2,3.1 c-0.9,0.2-1.9,0.4-2.8,0.5c-0.9,0.2-1.8,0.2-2.7,0.2l0.1,0c-3.2,0-6.1,1.6-7.8,4.1c-0.1,0.1-0.2,0.3-0.3,0.5s-0.3,0.4-0.4,0.7 c-0.1,0.2-0.2,0.5-0.3,0.7c-0.1,0.2-0.2,0.5-0.3,0.7c-0.3,0.9-0.5,1.9-0.5,2.9v12H13.1z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowLaneChangeRight);
export default __webpack_public_path__ + "static/media/arrow-lane-change-right.ec46a5fa8c34b611cac7c49abf899692.svg";
export { ForwardRef as ReactComponent };